import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isKycApproved } from '../utils/kyc';
import './KycGate.css';

function KycGate({ children }) {
  const { user, isAdmin, getKYCStatus } = useAuth();

  if (isAdmin() || isKycApproved(getKYCStatus()) || user?.role === 'moderator') {
    return children;
  }

  const status = getKYCStatus();
  const statusLabel = status === 'rejected'
    ? 'Rejected'
    : status === 'pending'
      ? 'Under review'
      : 'Not submitted';

  return (
    <div className="kyc-gate">
      <div className="kyc-gate-card">
        <div className="kyc-gate-icon">🆔</div>
        <h1>KYC verification required</h1>
        <p>
          Complete identity verification to access wallet, deposits, withdrawals, and trading.
          Email verification is not required.
        </p>
        <div className="kyc-gate-status">
          Current status: <strong>{statusLabel}</strong>
        </div>
        <div className="kyc-gate-actions">
          <Link to="/kyc-verification" className="kyc-gate-primary">
            {status === 'rejected' ? 'Resubmit KYC' : 'Go to KYC'}
          </Link>
          <Link to="/dashboard" className="kyc-gate-secondary">Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}

export default KycGate;
